import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {tap} from 'rxjs/operators';
import { LoadingService } from '../common/loading.service';
import { CookieService } from './cookies';
import { AuthService } from './auth.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    
    constructor(private loading : LoadingService, private cookies : CookieService, private auth : AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with basic auth credentials if available
        this.loading.requestStarted();
        let currentUser = localStorage.getItem('currentUser');
        let authorizationData = 'Basic ' + btoa('c2eXO9KyeZQG6NcZYaSDMn9htOR5NTts' + ':' + 'X');

        if (currentUser) {
            if(request.url.indexOf('postcode') > 0){
                //do nothing
            }else if(request.url.indexOf('signable') > 0){
                request = request.clone({
                    setHeaders: { 
                        Authorization: authorizationData
                    }
                });
            }else{
                request = request.clone({
                    setHeaders: { 
                        Authorization: currentUser
                    }
                });
            }
        }
        // return next.handle(request).pipe( tap(() => {},
        // (err: any) => ));
        return this.handler(next, request);
    }

    handler(next, request){
        return next.handle(request).pipe(
            tap(
                (event)=>{
                    if(event instanceof HttpResponse){
                        this.loading.requestEnded();
                    }
                },
                (error : HttpErrorResponse)=>{
                    if (error instanceof HttpErrorResponse) {
                        // console.log(error.status);
                        this.loading.resetSpinner();
                        if (error.status !== 0) {
                        return;
                        }
                        // this.auth.logOut();
                    }
                }
            )
        )
    }

   
}